import * as React from 'react'
import * as style from './index.module.css'

/**
 * Company
 */
export const Company = (): React.JSX.Element => {
  return (
    <>
      <div className={`${style.row} ${style.border}`}>
        <p className={`${style.position} ${style.title}`}>会社名</p>
        <p className={`${style.position} ${style.content}`}>株式会社SOZO</p>
      </div>
      <div className={`${style.row} ${style.border}`}>
        <p className={`${style.position} ${style.title}`}>会社名（カナ）</p>
        <p className={`${style.position} ${style.content}`}>
          カブシキカイシャソウゾウ
        </p>
      </div>
      <div className={`${style.row} ${style.border}`}>
        <p className={`${style.position} ${style.title}`}>設立</p>
        <p className={`${style.position} ${style.content}`}>2024/10/29</p>
      </div>
      <div className={`${style.row} ${style.border}`}>
        <p className={`${style.position} ${style.title}`}>代表取締役</p>
        <p className={`${style.position} ${style.content}`}>一場 滉平</p>
      </div>
      <div className={`${style.row} ${style.border}`}>
        <p className={`${style.position} ${style.title}`}>資本金</p>
        <p className={`${style.position} ${style.content}`}>3,000,000円</p>
      </div>
      <div className={`${style.row} ${style.border}`}>
        <p className={`${style.position} ${style.title}`}>事業内容</p>
        <ul className={style.ulArea}>
          <li className={style.content}>Webコンテンツの企画・制作事業</li>
          <li className={style.content}>IT・Web領域における教育</li>
          <li className={style.content}>システムエンジニアリング事業</li>
        </ul>
      </div>
      <div className={`${style.row}`}>
        <p className={`${style.position} ${style.title}`}>所在地</p>
        <div className={`${style.column}`}>
          <ul className={style.ulArea}>
            <li className={style.content}>〒154-0012</li>
            <li className={style.content}>
              東京都世田谷区駒沢５丁目２６−７ 駒沢パークサイドテラスノース 1F
            </li>
          </ul>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3243.023412708662!2d139.65484706042284!3d35.62714932066487!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f50b825e5a41%3A0x8450edc30c12e078!2z5qCq5byP5Lya56S-U09aTw!5e0!3m2!1sja!2sjp!4v1730434369003!5m2!1sja!2sjp"
            width="100%"
            height="420px"
            loading="lazy"
            className={style.adressMap}
          />
        </div>
      </div>
    </>
  )
}
